import { render, staticRenderFns } from "./player-redbag.vue?vue&type=template&id=050002da&scoped=true&"
import script from "./player-redbag.vue?vue&type=script&lang=js&"
export * from "./player-redbag.vue?vue&type=script&lang=js&"
import style0 from "./player-redbag.vue?vue&type=style&index=0&id=050002da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050002da",
  null
  
)

export default component.exports